(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-save"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'symbol',
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function initBundleSave(root) {
      if (root.__bundleSaveInit) return;
      root.__bundleSaveInit = true;

      var variantsScript = root.querySelector('[data-bundle-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
      var variantsById = {};
      variants.forEach(function (v) {
        variantsById[v.id] = v;
      });

      var discount2 = parseFloat(root.getAttribute('data-discount-2') || '10') / 100;
      var discount3 = parseFloat(root.getAttribute('data-discount-3') || '20') / 100;
      var currency = root.getAttribute('data-currency') || 'USD';
      var defaultVariantId = root.getAttribute('data-default-variant-id');

      var container = root.closest('.product-details') || document;
      var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-tier]'));
      var selectedQty = 1;

      function currentVariantId() {
        var idInput = container.querySelector('input[name="id"]');
        return (idInput && idInput.value) || defaultVariantId;
      }

      function render() {
        var variant = variantsById[currentVariantId()] || variantsById[defaultVariantId] || variants[0];
        if (!variant) return;

        var base = variant.price;

        var variantLabel = root.querySelector('[data-bundle-variant-label]');
        if (variantLabel) variantLabel.textContent = variant.title;

        tiers.forEach(function (tier) {
          var qty = parseInt(tier.getAttribute('data-qty'), 10);
          var rate = qty === 2 ? discount2 : qty === 3 ? discount3 : 0;
          var full = base * qty;
          var discounted = Math.round(full * (1 - rate));
          var save = full - discounted;

          var priceEl = tier.querySelector('[data-bundle-price]');
          var compareEl = tier.querySelector('[data-bundle-compare]');
          var saveLine = tier.querySelector('[data-bundle-save-line]');
          var saveAmountEl = tier.querySelector('[data-bundle-save-amount]');

          if (priceEl) priceEl.textContent = formatMoney(discounted, currency);

          if (save > 0) {
            if (compareEl) {
              compareEl.textContent = formatMoney(full, currency);
              compareEl.hidden = false;
            }
            if (saveLine) saveLine.hidden = false;
            if (saveAmountEl) saveAmountEl.textContent = formatMoney(save, currency);
          } else {
            if (compareEl) compareEl.hidden = true;
            if (saveLine) saveLine.hidden = true;
          }
        });
      }

      function selectTier(qty) {
        selectedQty = qty;
        tiers.forEach(function (tier) {
          var tierQty = parseInt(tier.getAttribute('data-qty'), 10);
          var isSelected = tierQty === qty;
          tier.classList.toggle('is-selected', isSelected);
          var input = tier.querySelector('input[type="radio"]');
          if (input) input.checked = isSelected;
        });

        var qtyInput = container.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('blur', { bubbles: true }));
        }
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          var qty = parseInt(tier.getAttribute('data-qty'), 10);
          selectTier(qty);
        });
      });

      var idInput = container.querySelector('input[name="id"]');
      if (idInput) {
        var lastVariantId = idInput.value;
        new MutationObserver(function () {
          if (idInput.value !== lastVariantId) {
            lastVariantId = idInput.value;
            render();
          }
        }).observe(idInput, { attributes: true, attributeFilter: ['value'] });

        document.addEventListener('change', function () {
          requestAnimationFrame(function () {
            if (idInput.value !== lastVariantId) {
              lastVariantId = idInput.value;
              render();
            }
          });
        });
      }

      render();
      selectTier(1);
    }

    function initAll() {
      document.querySelectorAll('[data-bundle-save]').forEach(initBundleSave);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
